export default "__VITE_ASSET__CPtFS$EZ__"